import { render, staticRenderFns } from "./Federation.vue?vue&type=template&id=ea07b92e&scoped=true"
import script from "./Federation.vue?vue&type=script&lang=js"
export * from "./Federation.vue?vue&type=script&lang=js"
import style0 from "./Federation.vue?vue&type=style&index=0&id=ea07b92e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea07b92e",
  null
  
)

export default component.exports